type Environment = 'local' | 'development' | 'production';
export const ENVIRONMENT: Environment = process.env.NODE_ENV ?? 'local';